export enum ROUTE {
  CAMPAIGNS = '/campaigns',
  EVENTS = '/events',
  FRAUD = '/fraud',
  FRAUD_TEMPLATES = '/fraud-templates',
  LOGIN = '/login',
  LOGOUT = '/logout',
  MAIN = '/main',
  OFFERS = '/offers',
  PROVIDERS = '/providers',
  REPORTS = '/reports',
  ROOT = '/',
  USER_ACCOUNT = '/user/account',
  WELCOME = '/welcome',
  FORGOT_PASSWORD = '/forgot-password',
  EMMA = '/emma',
}
